import { render, staticRenderFns } from "./VDragDropFileInput.vue?vue&type=template&id=7a641351&scoped=true&"
import script from "./VDragDropFileInput.vue?vue&type=script&lang=ts&"
export * from "./VDragDropFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./VDragDropFileInput.vue?vue&type=style&index=0&id=7a641351&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a641351",
  null
  
)

export default component.exports